/* eslint-disable */
// Auto-extracted verbatim from the original SCT NOC tracker — DO NOT hand-edit the
// config data; it must stay identical to the original tool.

/* ---------- Theme palettes ---------- */
const THEMES = {
  dark: {
    label: "Dark", swatch: "#4CC9F0",
    bg: "#0A0F1C", panel: "#111A2C", panelBorder: "#1E2C46",
    cyan: "#4CC9F0", amber: "#F5A623", red: "#E5484D", green: "#3DDC97",
    textPrimary: "#E6EDF3", textMuted: "#7C8AA0", inputBg: "#0A121F",
    overlay: "rgba(5,8,15,0.7)", rowAlt: "rgba(255,255,255,0.015)", btnText: "#00121A",
  },
  light: {
    label: "Light", swatch: "#0B7DA8",
    bg: "#F4F6FA", panel: "#FFFFFF", panelBorder: "#DCE2ED",
    cyan: "#0B7DA8", amber: "#B5720A", red: "#C7333A", green: "#188A5C",
    textPrimary: "#101826", textMuted: "#5C6B85", inputBg: "#FFFFFF",
    overlay: "rgba(20,26,38,0.35)", rowAlt: "rgba(15,25,45,0.025)", btnText: "#FFFFFF",
  },
};

const STATUSES = ["Open", "In Progress", "Resolved"];
const SITE_VISIT_STATUSES = ["Scheduled", "In Progress", "Completed"];
const ROLES = ["user", "admin", "superadmin"];
const ROLE_LABEL = { user: "User", admin: "Admin", superadmin: "Super Admin" };

function statusColor(status, t) {
  if (status === "Open") return t.red;
  if (status === "In Progress") return t.amber;
  if (status === "Scheduled") return t.cyan;
  return t.green;
}
function roleColor(role, t) {
  if (role === "superadmin") return t.red;
  if (role === "admin") return t.cyan;
  return t.textMuted;
}
function canManageUsers(role) { return role === "superadmin"; }
function canDelete(role) { return role === "admin" || role === "superadmin"; }

function defaultShiftConfig() {
  return [
    { name: "A1", start: "07:30", end: "14:00" },
    { name: "A2", start: "14:00", end: "22:00" },
    { name: "N", start: "22:00", end: "07:30" },
  ];
}

function defaultSystemsConfig() {
  return [
    "Starlink", "VSAT", "RF", "Antenna / ACU", "HPA", "LNB / BUC", "Modem",
    "NMS", "Redundancy Manager", "Spectrum Analyzer", "Network", "Fiber Link",
    "Teleport", "Power / UPS", "Generator", "Camera", "Access Control",
    "Voice / Telephony", "Customer",
  ];
}

function defaultCompaniesConfig() {
  return {
    Starlink: ["China Electrical Power", "Aledrak", "Concept Tech.", "LNG", "SLB", "CCED", "SLDC", "Lulu", "Sohar A", "XYZ", "MOE", "MOH", "MOI", "World Health Organization"],
    VSAT: {
      "Beam 1": ["Alhishman", "Flyaway", "Haima", "Mobile 1", "Mobile 2", "Mobile 3", "Mobile 4", "Mobile 5", "Mobile 6", "B1Witness", "Motorela_POC", "starwin_int", "U7720_external", "RAFO", "B1sitIFLoop", "XOM_1", "XOM_2", "XOM_3", "XOM_4", "XOM_5", "XOM_6"],
      "Beam 2": ["Almuazir", "Alraasikh", "Conqueror_of_Waves", "Flyaway", "KHASAB", "Lima", "Mahadha", "Mobile 1", "Mobile 2", "Mobile 3", "Mobile 4", "Mobile 5", "Mobile 6", "W.AL-Baih", "LuLu", "Senina", "U77720_internal", "U77720_external", "starwin", "iTest", "Motorela_POC", "RAFO_1", "MS0050"],
    },
  };
}
function vsatBeams() {
  return ["Beam 1", "Beam 2"];
}
function companyLabelForSystem(system) {
  if (system === "Starlink") return "SL Companies";
  if (system === "VSAT") return "VSAT Companies";
  return `${system} Companies`;
}

function defaultCategoryConfig() {
  return {
    Starlink: [
      { name: "Dish / Terminal", subs: ["Obstruction", "Misalignment", "Firmware Update Stuck", "Hardware Fault"] },
      { name: "Router / Wi-Fi", subs: ["No Connection", "Slow Speeds", "Firmware Issue", "Configuration"] },
      { name: "Connectivity", subs: ["Outage", "Intermittent Drop", "High Latency", "Low Throughput"] },
      { name: "Account / Subscription", subs: ["Billing Issue", "Plan Change", "Service Suspension"] },
      { name: "Power", subs: ["Power Outage", "Cable / PoE Fault"] },
      { name: "Weather", subs: ["Snow / Ice Cover", "Storm Damage"] },
      { name: "Other", subs: ["Unspecified", "Customer Request", "Scheduled Maintenance"] },
    ],
    VSAT: [
      { name: "Antenna / Dish", subs: ["Misalignment", "Physical Damage", "Motor / Actuator Fault", "Obstruction"] },
      { name: "Modem / Router", subs: ["No Sync", "Firmware Issue", "Configuration Error", "Hardware Failure"] },
      { name: "Signal Quality", subs: ["Low SNR", "High BER", "Rain Fade", "Interference"] },
      { name: "Power", subs: ["Power Outage", "UPS Failure", "Cabling Issue"] },
      { name: "Network", subs: ["IP Conflict", "Routing Issue", "Latency / Packet Loss"] },
      { name: "Weather", subs: ["Rain Fade", "Wind Damage", "Lightning Strike"] },
      { name: "Other", subs: ["Unspecified", "Customer Request", "Scheduled Maintenance"] },
    ],
    RF: [
      { name: "Signal Quality", subs: ["Low SNR", "High BER", "Interference", "Signal Loss"] },
      { name: "Amplifier", subs: ["Gain Fault", "Overdrive", "Temperature Trip"] },
      { name: "Cabling / Connectors", subs: ["Loose Connector", "Cable Damage", "Water Ingress"] },
      { name: "Frequency", subs: ["Frequency Drift", "Wrong Polarization"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Antenna / ACU": [
      { name: "Tracking", subs: ["Loss of Track", "Tracking Error", "Program Track Fault"] },
      { name: "Positioner", subs: ["Motor Fault", "Encoder Fault", "Limit Switch Triggered"] },
      { name: "Structural", subs: ["Physical Damage", "Obstruction", "Misalignment"] },
      { name: "ACU Software", subs: ["Firmware Issue", "Configuration Error", "Communication Loss"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    HPA: [
      { name: "Power Output", subs: ["Low Output Power", "No Output", "Output Fluctuation"] },
      { name: "Fault Alarms", subs: ["Over Temperature", "VSWR Fault", "Interlock Trip"] },
      { name: "Power Supply", subs: ["PSU Failure", "Voltage Fluctuation"] },
      { name: "Cooling", subs: ["Fan Failure", "Overheating"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "LNB / BUC": [
      { name: "LNB", subs: ["No Signal", "LO Drift", "DC Fault"] },
      { name: "BUC", subs: ["Low Power Output", "No Power", "Overcurrent"] },
      { name: "Cabling", subs: ["Cable Fault", "Connector Corrosion"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    Modem: [
      { name: "Sync", subs: ["No Sync", "Intermittent Sync Loss"] },
      { name: "Configuration", subs: ["Wrong Config", "Firmware Update Needed"] },
      { name: "Hardware", subs: ["Hardware Failure", "Port Failure"] },
      { name: "Performance", subs: ["Low Throughput", "High Latency"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    NMS: [
      { name: "Alarms", subs: ["False Alarm", "Missed Alarm", "Alarm Flooding"] },
      { name: "Connectivity", subs: ["Agent Offline", "SNMP Timeout"] },
      { name: "Software", subs: ["Bug", "Update Required", "License Issue"] },
      { name: "Reporting", subs: ["Incorrect Data", "Dashboard Fault"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Redundancy Manager": [
      { name: "Switchover", subs: ["Failed Switchover", "Unexpected Switchover", "Delayed Switchover"] },
      { name: "Unit Status", subs: ["Standby Unit Fault", "Primary Unit Fault"] },
      { name: "Configuration", subs: ["Sync Error", "Configuration Mismatch"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Spectrum Analyzer": [
      { name: "Measurement", subs: ["Incorrect Reading", "Calibration Needed"] },
      { name: "Hardware", subs: ["Device Fault", "Connectivity Loss"] },
      { name: "Interference", subs: ["Unknown Interference", "Adjacent Carrier Interference"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    Network: [
      { name: "Connectivity", subs: ["Link Down", "Packet Loss", "High Latency"] },
      { name: "Routing", subs: ["Routing Loop", "BGP / OSPF Fault"] },
      { name: "Security", subs: ["Unauthorized Access", "Firewall Block", "DDoS"] },
      { name: "Hardware", subs: ["Switch Failure", "Router Failure"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Fiber Link": [
      { name: "Physical", subs: ["Fiber Cut", "Connector Damage", "Bend Loss"] },
      { name: "Signal", subs: ["Low Optical Power", "High Attenuation"] },
      { name: "Equipment", subs: ["Transceiver Failure", "Media Converter Fault"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    Teleport: [
      { name: "Facility", subs: ["Power Outage", "HVAC Failure", "Access Issue"] },
      { name: "Equipment", subs: ["Rack Fault", "Cabling Issue"] },
      { name: "Coordination", subs: ["Scheduling Conflict", "Frequency Coordination Issue"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Power / UPS": [
      { name: "UPS", subs: ["Battery Failure", "Overload", "Bypass Fault"] },
      { name: "Mains", subs: ["Power Outage", "Voltage Fluctuation", "Phase Failure"] },
      { name: "Distribution", subs: ["PDU Fault", "Breaker Trip"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    Generator: [
      { name: "Startup", subs: ["Failed to Start", "Delayed Start"] },
      { name: "Fuel", subs: ["Low Fuel", "Fuel Contamination"] },
      { name: "Mechanical", subs: ["Engine Fault", "Overheating"] },
      { name: "Electrical", subs: ["Alternator Fault", "ATS Fault"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    Camera: [
      { name: "Video", subs: ["No Signal", "Poor Image Quality", "Frozen Feed"] },
      { name: "Hardware", subs: ["Camera Offline", "Lens / Housing Damage"] },
      { name: "Storage", subs: ["Recording Failure", "Storage Full"] },
      { name: "Network", subs: ["Connectivity Loss", "PoE Fault"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Access Control": [
      { name: "Door / Gate", subs: ["Door Not Locking", "Gate Malfunction"] },
      { name: "Reader / Badge", subs: ["Card Reader Fault", "Badge Not Recognized"] },
      { name: "System", subs: ["Software Fault", "Database Sync Error"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    "Voice / Telephony": [
      { name: "Line", subs: ["No Dial Tone", "One-Way Audio", "Call Drops"] },
      { name: "PABX", subs: ["System Fault", "Configuration Error"] },
      { name: "Network", subs: ["VoIP Quality Issue", "Registration Failure"] },
      { name: "Other", subs: ["Unspecified", "Scheduled Maintenance"] },
    ],
    Customer: [
      { name: "Service", subs: ["Service Outage", "Degraded Performance"] },
      { name: "Billing", subs: ["Billing Dispute", "Payment Issue"] },
      { name: "Request", subs: ["New Service Request", "Change Request"] },
      { name: "Support", subs: ["Technical Question", "Training Request"] },
      { name: "Other", subs: ["Unspecified"] },
    ],
    _default: [
      { name: "Hardware", subs: ["General Fault", "Physical Damage", "Unspecified"] },
      { name: "Software", subs: ["Bug", "Configuration Error", "Update Required"] },
      { name: "Network", subs: ["Connectivity Loss", "Latency", "Routing Issue"] },
      { name: "Other", subs: ["Unspecified", "Customer Request"] },
    ],
  };
}


function timeStrToMinutes(hhmm) {
  const [h, m] = (hhmm || "00:00").split(":").map(Number);
  return h * 60 + (m || 0);
}

function detectShift(date, config) {
  const mins = date.getHours() * 60 + date.getMinutes();
  for (const s of config) {
    const start = timeStrToMinutes(s.start);
    const end = timeStrToMinutes(s.end);
    if (start === end) continue;
    if (start < end) {
      if (mins >= start && mins < end) return s.name;
    } else {
      // wraps past midnight
      if (mins >= start || mins < end) return s.name;
    }
  }
  return config.length ? config[0].name : "—";
}

function genTicketId(tickets, system, cfg) {
  const base = (cfg && cfg.prefix) || 'SCT';
  const sysLabel = (system || base).trim();
  const prefix = `${base}-${sysLabel}_`;
  let max = (cfg && cfg.start) ? (parseInt(cfg.start, 10) - 1) : 0;
  (tickets || []).forEach((tk) => {
    const m = new RegExp(`^${prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\d+)$`, "i").exec(tk.id || "");
    if (m) max = Math.max(max, parseInt(m[1], 10));
  });
  const next = String(max + 1).padStart(2, "0");
  return `${prefix}${next}`;
}
function genSiteVisitId(visits, system, cfg) {
  const base = (cfg && cfg.prefix) || 'SCT';
  const sysLabel = (system || base).trim();
  const prefix = `${base}-${sysLabel}_`;
  let max = 0;
  (visits || []).forEach((v) => {
    const m = new RegExp(`^${prefix.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\d+)$`, "i").exec(v.id || "");
    if (m) max = Math.max(max, parseInt(m[1], 10));
  });
  const next = String(max + 1).padStart(2, "0");
  return `${prefix}${next}`;
}
function timeAgo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}
function formatDate(iso) {
  return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}
function formatTime(iso) {
  return new Date(iso).toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
}
function formatDuration(ms) {
  if (ms < 0) ms = 0;
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  const remMins = mins % 60;
  if (hrs < 24) return `${hrs}h ${remMins}m`;
  const days = Math.floor(hrs / 24);
  const remHrs = hrs % 24;
  return `${days}d ${remHrs}h`;
}
function computedReportStatus(r) {
  const abnormalIf = [
    r.beam1Health === "Abnormal" || r.beam1Health === "Down",
    r.beam2Health === "Abnormal" || r.beam2Health === "Down",
    r.beam3Health === "Abnormal" || r.beam3Health === "Down",
    r.redundancy === "Down",
    r.rfAlarm === "System abnormal",
    r.nocPhone === "Not working",
    r.overallStatus === "Abnormal",
  ];
  return abnormalIf.some(Boolean) ? "Abnormal" : "Normal";
}

function statusPill(t, status) {
  const isAbnormal = status === "Abnormal";
  const color = status ? (isAbnormal ? t.red : t.green) : t.textMuted;
  const bg = status ? (isAbnormal ? "rgba(229,72,77,0.12)" : "rgba(61,220,151,0.12)") : "transparent";
  return `<span class="mono" style="display:inline-block;padding:3px 9px;border-radius:20px;background:${bg};color:${color};font-size:10px;font-weight:700;letter-spacing:0.5px;">${esc(status || "—")}</span>`;
}

function esc(str) {
  return String(str ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

function emptyShiftForm() {
  return {
    name: "",
    shiftType: "",
    beam1Health: "", beam1Terminals: "",
    beam2Health: "", beam2Terminals: "",
    beam3Health: "", beam3Terminals: "",
    redundancy: "",
    rfAlarm: "", trackingSignal: "", antennaHubTemp: "", shelterTemp: "",
    hpa1: "", hpa2: "", hpa3: "", spectrumDb: "",
    nocPhone: "", overallStatus: "", comments: "",
  };
}

function emptySiteVisitForm() {
  return {
    id: "",
    site: "",
    technician: "",
    system: "",
    purpose: "",
    notes: "",
  };
}


export { THEMES, STATUSES, SITE_VISIT_STATUSES, ROLES, ROLE_LABEL, statusColor, roleColor,
  defaultShiftConfig, defaultSystemsConfig, defaultCompaniesConfig, defaultCategoryConfig,
  vsatBeams, companyLabelForSystem, timeStrToMinutes, detectShift, genTicketId, genSiteVisitId, timeAgo };
